import { render, staticRenderFns } from "./FmSwitch.vue?vue&type=template&id=023f2f1f&"
import script from "./FmSwitch.vue?vue&type=script&lang=js&"
export * from "./FmSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FmSwitch.vue?vue&type=style&index=0&id=023f2f1f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports